import type { Stage } from '../../types/Stage';

import downloadedMaterials from './materials-list.json';

export type MaterialItem = {
  key: string;
  image?: string;
};

export type MaterialList = Record<string, MaterialItem>;

export type MaterialsData = {
  SECONDARY_MATERIALS: MaterialList;
  EARLY_YEAR_MATERIALS: MaterialList;
  PRIMARY_MATERIALS: MaterialList;
};

const typedDownloadedMaterials: MaterialsData =
  downloadedMaterials as MaterialsData;

export const getMaterialsByStage = (stage: Stage): MaterialList => {
  const stageMaterials: Record<Stage, MaterialList> = {
    1: typedDownloadedMaterials.EARLY_YEAR_MATERIALS,
    2: typedDownloadedMaterials.PRIMARY_MATERIALS,
    3: typedDownloadedMaterials.SECONDARY_MATERIALS,
  };

  return stageMaterials[stage] || {};
};
